import React from 'react'
import css from './style.scss'
import moment from 'moment'
import PauseIcon from 'react-icons/lib/md/pause-circle-filled'

export default (props)=>{
  const when = moment(props.when).format("DD MMMM YYYY")
  return (
    <div>
      <div className={css.pausedBarContainer}>
        <PauseIcon size={32}/>
        <p>This account was paused on <b>{when}</b>, so stories created after this data won't be here.</p>
      </div>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/account_page/account_info/paused_bar/index.js